import '../css/chart.css'
import { Button, Container, IconButton } from '@mui/material';
import { QueryObserver, useMutation, useQuery } from "@tanstack/react-query";
import { timeEnd } from 'console';
import { useEffect, useRef, useState } from 'react';
import { fetchNewPlanets } from '../api/fetchNewPlanets';
import dayjs from 'dayjs';
import useGetFetchNewPlanets from '../api/useGetFetchNewPlanets';
import { KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, Padding } from '@mui/icons-material';
import { styled } from '@mui/system';
import { CurvedRightArrow } from './curved-right-arrow';
import { CurvedLeftArrow } from './curved-left-arrow';

export const ChartMonthArrow = (props:any) => {

    const DateTimeFieldLg= styled(KeyboardDoubleArrowRight,{})({

        ".MuiButtonBase-root":{
          padding: '0'
        
        
      }});

    const StyledButton= styled(IconButton,{})({
        color: 'rgba(0,0,0,70)',
        justifyContent: 'center',
        ':hover':{
            backgroundColor: 'rgba(156, 236, 246,.20);'
        }
    })
    
    const StyledContainer= styled(Container,{})({
        
        paddingLeft: '0px',
        paddingRight: '0px',
        paddingTop:'0px',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        '@media (min-width: 600px)':{
            paddingLeft: '0px',
            paddingRight: '0px',

        }
    })
    
    let varTid=''
    let planet = null
    let degree = null
    let sign = null
    let minute = null
    let rx = null

    interface ChartInfo  {
    
        utc_date: any;
        signs: any;
        planets: any;
    
  }
  interface ChartData {
    
    tid: any;
    ptid: any;
    timezone: any; 
    lat: any;
    long: any;

}

    async function fetchNewPlanets(direction: string, interval: string, tid: string, lat: string, long: string): Promise<ChartInfo> {
        const response = 
        (process.env.NODE_ENV=='development') ?
        await fetch(`http://localhost:8000/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}&timezone=${props.timezone.current}`)
        :
        await fetch(`https://api.planetgazer.net/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}&timezone=${props.timezone.current}`);
    
        return response.json();
      }

    async function fetchCustomPlanets( wheel_type: string, direction: string, interval: string, chartData: ChartData): Promise<ChartInfo>{

        const response = 
        (process.env.NODE_ENV=='development') ?
        await fetch(`http://localhost:8000/${wheel_type}/${direction}/${interval}`, {
            method:"POST",
            body: JSON.stringify(chartData),
            headers: {"Content-type": "application/json; charset=UTF-8"}
        })
        :
        await fetch(`https://api.planetgazer.net/${wheel_type}/${direction}/${interval}`,{
            method:"POST",
            body: JSON.stringify(chartData),
            headers: {"Content-type": "application/json; charset=UTF-8"}
        })

        return response.json()
      }
        
    const {data: transits , error:error, isLoading: isLoading, isSuccess: SuccessTransit, refetch: fetchChart} = useQuery<ChartInfo>(
        { 

        queryKey: ['transits','forward','month',varTid],
        queryFn: () => fetchNewPlanets('forward','month',varTid, props.lat.current, props.long.current),
        enabled: false,
        staleTime: Infinity
    
        });


    const { data: custom, isSuccess: SuccessCustom, mutate } = useMutation({    

        mutationFn: (chartData: any) => fetchCustomPlanets(props.wheelType,'forward','month',chartData)
   
        });

    
    const handleForwardClick  = async  () => { 

            props.setSelectedSectionType("month");
            props.dayCount.current += 
            props.setDefaultDate(props.defaultDate.add(1, 'month'))
            let date = dayjs(props.defaultDate).add(1, 'month')
            varTid = date.toDate().toLocaleString('sv', { timeZoneName: 'short' }).split(" ")[0]
            + "T" + date.toDate().toLocaleString('sv', { timeZoneName: 'short' }).split(" ")[1]
            //varTid  = dayjs(props.defaultDate).add(1, 'day').toISOString()
            console.log(varTid)
            props.setAllowedToFetch(false)
            if (props.wheelType==''){
                await fetchChart()
            }
            else{
                const chartData = {datetime: varTid, root_datetime: props.ptid.current, timezone: props.timezone.current, lat: String(props.lat.current), long: String(props.long.current)};
                await mutate(chartData)     
            }

            
       };

       const handleBackClick  = async  () => { 

        props.setSelectedSectionType("month");
        props.dayCount.current += 
        props.setDefaultDate(props.defaultDate.subtract(1, 'month'))
        let date = dayjs(props.defaultDate).subtract(1, 'month')
        varTid = date.toDate().toLocaleString('sv', { timeZoneName: 'short' }).split(" ")[0]
        + "T" + date.toDate().toLocaleString('sv', { timeZoneName: 'short' }).split(" ")[1]
        //varTid  = dayjs(props.defaultDate).subtract(1, 'day').toISOString()
        console.log(varTid)
        props.setAllowedToFetch(false)
        if (props.wheelType==''){
            await fetchChart()
        }
        else{
            const chartData = {datetime: varTid, root_datetime: props.ptid.current, timezone: props.timezone.current, lat: String(props.lat.current), long: String(props.long.current)};
            await mutate(chartData)     
        }

        
   };

   
    console.log(props.wheelType)

    useEffect(() => {
       if(SuccessTransit){

            if (transits !== null || transits !== undefined)
                {props.tid.current = transits?.utc_date}
            

            console.log("ptid:" + props.ptid.current)
            console.log("tid:" + props.tid.current)

            console.log(transits)

            props.setSignVals({
                AriSignX: transits?.signs[0].coord[0],
                AriSignY: transits?.signs[0].coord[1],
                TauSignX: transits?.signs[1].coord[0],
                TauSignY: transits?.signs[1].coord[1],
                GemSignX: transits?.signs[2].coord[0],
                GemSignY: transits?.signs[2].coord[1],
                CanSignX: transits?.signs[3].coord[0],
                CanSignY: transits?.signs[3].coord[1],
                LeoSignX: transits?.signs[4].coord[0],
                LeoSignY: transits?.signs[4].coord[1],
                VirSignX: transits?.signs[5].coord[0],
                VirSignY: transits?.signs[5].coord[1],
                LibSignX: transits?.signs[6].coord[0],
                LibSignY: transits?.signs[6].coord[1],
                ScoSignX: transits?.signs[7].coord[0],
                ScoSignY: transits?.signs[7].coord[1],
                SagSignX: transits?.signs[8].coord[0],
                SagSignY: transits?.signs[8].coord[1],
                CapSignX: transits?.signs[9].coord[0],
                CapSignY: transits?.signs[9].coord[1],
                AquSignX: transits?.signs[10].coord[0],
                AquSignY: transits?.signs[10].coord[1],
                PisSignX: transits?.signs[11].coord[0],
                PisSignY: transits?.signs[11].coord[1]
        
            })

            
            transits?.planets.map((p: any) => { 

                if (p.planet == "Mo") {
                    props.setMoVals({  
                        MoSym:"R", 
                        MoPlanetX: p.coord[0][0],
                        MoPlanetY: p.coord[0][1],
                        MoSign: p.sign,
                        MoSignSym: p.signSymbol,
                        MoSignX: p.coord[2][0],
                        MoSignY: p.coord[2][1],
                        MoDegree: p.degree,
                        MoDegreeX: p.coord[1][0],
                        MoDegreeY: p.coord[1][1],
                        MoMinute: p.minute,
                        MoMinuteX: p.coord[3][0],
                        MoMinuteY: p.coord[3][1],
                    })
                }
                if (p.planet == "Me") { 
                    props.setMeVals({
                        MeSym:"S",          
                        MePlanetX: p.coord[0][0],
                        MePlanetY: p.coord[0][1],
                        MeSign: p.sign,
                        MeSignSym: p.signSymbol,
                        MeSignX: p.coord[2][0],
                        MeSignY: p.coord[2][1],
                        MeDegree: p.degree,
                        MeDegreeX: p.coord[1][0],
                        MeDegreeY: p.coord[1][1],
                        MeMinute: p.minute,
                        MeMinuteX: p.coord[3][0],
                        MeMinuteY: p.coord[3][1],
                        MeRX:  p.rx,
                        MeRXX: p.coord[4][0],
                        MeRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ve") { 
                    props.setVeVals({    
                        VeSym:"T",      
                        VePlanetX: p.coord[0][0],
                        VePlanetY: p.coord[0][1],
                        VeSign: p.sign,
                        VeSignSym: p.signSymbol,
                        VeSignX: p.coord[2][0],
                        VeSignY: p.coord[2][1],
                        VeDegree: p.degree,
                        VeDegreeX: p.coord[1][0],
                        VeDegreeY: p.coord[1][1],
                        VeMinute: p.minute,
                        VeMinuteX: p.coord[3][0],
                        VeMinuteY: p.coord[3][1],
                        VeRX:  p.rx,
                        VeRXX: p.coord[4][0],
                        VeRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Su") { 
                    props.setSuVals({ 
                        SuSym:p.planetSymbol,         
                        SuPlanetX: p.coord[0][0],
                        SuPlanetY: p.coord[0][1],
                        SuSign: p.sign,
                        SuSignSym: p.signSymbol,
                        SuSignX: p.coord[2][0],
                        SuSignY: p.coord[2][1],
                        SuDegree: p.degree,
                        SuDegreeX: p.coord[1][0],
                        SuDegreeY: p.coord[1][1],
                        SuMinute: p.minute,
                        SuMinuteX: p.coord[3][0],
                        SuMinuteY: p.coord[3][1],
                        SuRX: p.coord[4][0],
                        SuRY: p.coord[4][1]
                    })
                }
                
                if (p.planet == "Ma") { 
                    props.setMaVals({
                        MaSym:"U",          
                        MaPlanetX: p.coord[0][0],
                        MaPlanetY: p.coord[0][1],
                        MaSign: p.sign,
                        MaSignSym: p.signSymbol,
                        MaSignX: p.coord[2][0],
                        MaSignY: p.coord[2][1],
                        MaDegree: p.degree,
                        MaDegreeX: p.coord[1][0],
                        MaDegreeY: p.coord[1][1],
                        MaMinute: p.minute,
                        MaMinuteX: p.coord[3][0],
                        MaMinuteY: p.coord[3][1],
                        MaRX: p.rx,
                        MaRXX: p.coord[4][0],
                        MaRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ju") { 
                    props.setJuVals({ 
                        JuSym:"V",         
                        JuPlanetX: p.coord[0][0],
                        JuPlanetY: p.coord[0][1],
                        JuSign: p.sign,
                        JuSignSym: p.signSymbol,
                        JuSignX: p.coord[2][0],
                        JuSignY: p.coord[2][1],
                        JuDegree: p.degree,
                        JuDegreeX: p.coord[1][0],
                        JuDegreeY: p.coord[1][1],
                        JuMinute: p.minute,
                        JuMinuteX: p.coord[3][0],
                        JuMinuteY: p.coord[3][1],
                        JuRX: p.rx,
                        JuRXX: p.coord[4][0],
                        JuRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Sa") { 
                    props.setSaVals({
                        SaSym:"W",          
                        SaPlanetX: p.coord[0][0],
                        SaPlanetY: p.coord[0][1],
                        SaSign: p.sign,
                        SaSignSym: p.signSymbol,
                        SaSignX: p.coord[2][0],
                        SaSignY: p.coord[2][1],
                        SaDegree: p.degree,
                        SaDegreeX: p.coord[1][0],
                        SaDegreeY: p.coord[1][1],
                        SaMinute: p.minute,
                        SaMinuteX: p.coord[3][0],
                        SaMinuteY: p.coord[3][1],
                        SaRX: p.rx,
                        SaRXX: p.coord[4][0],
                        SaRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ur") { 
                    props.setUrVals({  
                        UrSym:"X",        
                        UrPlanetX: p.coord[0][0],
                        UrPlanetY: p.coord[0][1],
                        UrSign: p.sign,
                        UrSignSym: p.signSymbol,
                        UrSignX: p.coord[2][0],
                        UrSignY: p.coord[2][1],
                        UrDegree: p.degree,
                        UrDegreeX: p.coord[1][0],
                        UrDegreeY: p.coord[1][1],
                        UrMinute: p.minute,
                        UrMinuteX: p.coord[3][0],
                        UrMinuteY: p.coord[3][1],
                        UrRX: p.rx,
                        UrRXX: p.coord[4][0],
                        UrRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ne") { 
                    props.setNeVals({  
                        NeSym:"Y",        
                        NePlanetX: p.coord[0][0],
                        NePlanetY: p.coord[0][1],
                        NeSign: p.sign,
                        NeSignSym: p.signSymbol,
                        NeSignX: p.coord[2][0],
                        NeSignY: p.coord[2][1],
                        NeDegree: p.degree,
                        NeDegreeX: p.coord[1][0],
                        NeDegreeY: p.coord[1][1],
                        NeMinute: p.minute,
                        NeMinuteX: p.coord[3][0],
                        NeMinuteY: p.coord[3][1],
                        NeRX: p.rx,
                        NeRXX: p.coord[4][0],
                        NeRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Pl") { 
                    props.setPlVals({   
                        PlSym:"Z",       
                        PlPlanetX: p.coord[0][0],
                        PlPlanetY: p.coord[0][1],
                        PlSign: p.sign,
                        PlSignSym: p.signSymbol,
                        PlSignX: p.coord[2][0],
                        PlSignY: p.coord[2][1],
                        PlDegree: p.degree,
                        PlDegreeX: p.coord[1][0],
                        PlDegreeY: p.coord[1][1],
                        PlMinute: p.minute,
                        PlMinuteX: p.coord[3][0],
                        PlMinuteY: p.coord[3][1],
                        PlRX: p.rx,
                        PlRXX: p.coord[4][0],
                        PlRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ra") { 
                    props.setRaVals({
                        RaSym:"<",          
                        RaPlanetX: p.coord[0][0],
                        RaPlanetY: p.coord[0][1],
                        RaSign: p.sign,
                        RaSignSym: p.signSymbol,
                        RaSignX: p.coord[2][0],
                        RaSignY: p.coord[2][1],
                        RaDegree: p.degree,
                        RaDegreeX: p.coord[1][0],
                        RaDegreeY: p.coord[1][1],
                        RaMinute: p.minute,
                        RaMinuteX: p.coord[3][0],
                        RaMinuteY: p.coord[3][1],
                        RaRX: p.rx,
                        RaRXX: p.coord[4][0],
                        RaRXY: p.coord[4][1],
                        RXSym: 'M' 
                    })
                }
                if (p.planet == "Ke") { 
                    props.setKeVals({ 
                        KeSym:">",         
                        KePlanetX: p.coord[0][0],
                        KePlanetY: p.coord[0][1],
                        KeSign: p.sign,
                        KeSignSym: p.signSymbol,
                        KeSignX: p.coord[2][0],
                        KeSignY: p.coord[2][1],
                        KeDegree: p.degree,
                        KeDegreeX: p.coord[1][0],
                        KeDegreeY: p.coord[1][1],
                        KeMinute: p.minute,
                        KeMinuteX: p.coord[3][0],
                        KeMinuteY: p.coord[3][1],
                        KeRX: p.rx,
                        KeRXX: p.coord[4][0],
                        KeRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ch") { 
                    props.setChVals({  
                        ChSym:"t",        
                        ChPlanetX: p.coord[0][0],
                        ChPlanetY: p.coord[0][1],
                        ChSign: p.sign,
                        ChSignSym: p.signSymbol,
                        ChSignX: p.coord[2][0],
                        ChSignY: p.coord[2][1],
                        ChDegree: p.degree,
                        ChDegreeX: p.coord[1][0],
                        ChDegreeY: p.coord[1][1],
                        ChMinute: p.minute,
                        ChMinuteX: p.coord[3][0],
                        ChMinuteY: p.coord[3][1],
                        ChRX: p.rx,
                        ChRXX: p.coord[4][0],
                        ChRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "ASC") { 
                    props.setASCVals({
                        ASCSym:"a",          
                        ASCPlanetX: p.coord[0][0],
                        ASCPlanetY: p.coord[0][1],
                        ASCSign: p.sign,
                        ASCSignSym: p.signSymbol,
                        ASCSignX: p.coord[2][0],
                        ASCSignY: p.coord[2][1],
                        ASCDegree: p.degree,
                        ASCDegreeX: p.coord[1][0],
                        ASCDegreeY: p.coord[1][1],
                        ASCMinute: p.minute,
                        ASCMinuteX: p.coord[3][0],
                        ASCMinuteY: p.coord[3][1]
                    })
        
                }
                if (p.planet == "DSC") { 
                    props.setDSCVals({
                        DSCSym:"DC",          
                        DSCPlanetX: p.coord[0][0],
                        DSCPlanetY: p.coord[0][1],
                        DSCSign: p.sign,
                        DSCSignSym: p.signSymbol,
                        DSCSignX: p.coord[2][0],
                        DSCSignY: p.coord[2][1],
                        DSCDegree: p.degree,
                        DSCDegreeX: p.coord[1][0],
                        DSCDegreeY: p.coord[1][1],
                        DSCMinute: p.minute,
                        DSCMinuteX: p.coord[3][0],
                        DSCMinuteY: p.coord[3][1]
                    })
                }
                if (p.planet == "IC") { 
                    props.setICVals({ 
                        ICSym:"c",         
                        ICPlanetX: p.coord[0][0],
                        ICPlanetY: p.coord[0][1],
                        ICSign: p.sign,
                        ICSignSym: p.signSymbol,
                        ICSignX: p.coord[2][0],
                        ICSignY: p.coord[2][1],
                        ICDegree: p.degree,
                        ICDegreeX: p.coord[1][0],
                        ICDegreeY: p.coord[1][1],
                        ICMinute: p.minute,
                        ICMinuteX: p.coord[3][0],
                        ICMinuteY: p.coord[3][1]
                    })
                }
                if (p.planet == "MC") { 
                    props.setMCVals({ 
                        MCSym:"b",         
                        MCPlanetX: p.coord[0][0],
                        MCPlanetY: p.coord[0][1],
                        MCSign: p.sign,
                        MCSignSym: p.signSymbol,
                        MCSignX: p.coord[2][0],
                        MCSignY: p.coord[2][1],
                        MCDegree: p.degree,
                        MCDegreeX: p.coord[1][0],
                        MCDegreeY: p.coord[1][1],
                        MCMinute: p.minute,
                        MCMinuteX: p.coord[3][0],
                        MCMinuteY: p.coord[3][1]
                    })
                }
                if (p.planet == "LoFo") { 
                    props.setLoFoVals({ 
                        LoFoSym:";",         
                        LoFoPlanetX: p.coord[0][0],
                        LoFoPlanetY: p.coord[0][1],
                        LoFoSign: p.sign,
                        LoFoSignSym: p.signSymbol,
                        LoFoSignX: p.coord[2][0],
                        LoFoSignY: p.coord[2][1],
                        LoFoDegree: p.degree,
                        LoFoDegreeX: p.coord[1][0],
                        LoFoDegreeY: p.coord[1][1],
                        LoFoMinute: p.minute,
                        LoFoMinuteX: p.coord[3][0],
                        LoFoMinuteY: p.coord[3][1]
                    })
                }
                
                })
            }
        }
        ,[transits])

        useEffect(() => {

            if(SuccessCustom){
  
                props.setSignBVals({
                    AriBSignX: custom?.signs[0].coord[0],
                    AriBSignY: custom?.signs[0].coord[1],
                    TauBSignX: custom?.signs[1].coord[0],
                    TauBSignY: custom?.signs[1].coord[1],
                    GemBSignX: custom?.signs[2].coord[0],
                    GemBSignY: custom?.signs[2].coord[1],
                    CanBSignX: custom?.signs[3].coord[0],
                    CanBSignY: custom?.signs[3].coord[1],
                    LeoBSignX: custom?.signs[4].coord[0],
                    LeoBSignY: custom?.signs[4].coord[1],
                    VirBSignX: custom?.signs[5].coord[0],
                    VirBSignY: custom?.signs[5].coord[1],
                    LibBSignX: custom?.signs[6].coord[0],
                    LibBSignY: custom?.signs[6].coord[1],
                    ScoBSignX: custom?.signs[7].coord[0],
                    ScoBSignY: custom?.signs[7].coord[1],
                    SagBSignX: custom?.signs[8].coord[0],
                    SagBSignY: custom?.signs[8].coord[1],
                    CapBSignX: custom?.signs[9].coord[0],
                    CapBSignY: custom?.signs[9].coord[1],
                    AquBSignX: custom?.signs[10].coord[0],
                    AquBSignY: custom?.signs[10].coord[1],
                    PisBSignX: custom?.signs[11].coord[0],
                    PisBSignY: custom?.signs[11].coord[1]
            
                })
            
                custom?.planets.map((p: any) => { 
            
                if (p.planet == "Mo") {
                    props.setMoBVals({  
                        MoBSym:"R", 
                        MoBPlanetX: p.coord[0][0],
                        MoBPlanetY: p.coord[0][1],
                        MoBSign: p.sign,
                        MoBSignSym: p.signSymbol,
                        MoBSignX: p.coord[2][0],
                        MoBSignY: p.coord[2][1],
                        MoBDegree: p.degree,
                        MoBDegreeX: p.coord[1][0],
                        MoBDegreeY: p.coord[1][1],
                        MoBMinute: p.minute,
                        MoBMinuteX: p.coord[3][0],
                        MoBMinuteY: p.coord[3][1],
                    })
                }
                if (p.planet == "Me") { 
                    props.setMeBVals({
                        MeBSym:"S",          
                        MeBPlanetX: p.coord[0][0],
                        MeBPlanetY: p.coord[0][1],
                        MeBSign: p.sign,
                        MeBSignSym: p.signSymbol,
                        MeBSignX: p.coord[2][0],
                        MeBSignY: p.coord[2][1],
                        MeBDegree: p.degree,
                        MeBDegreeX: p.coord[1][0],
                        MeBDegreeY: p.coord[1][1],
                        MeBMinute: p.minute,
                        MeBMinuteX: p.coord[3][0],
                        MeBMinuteY: p.coord[3][1],
                        MeBRX:  p.rx,
                        MeBRXX: p.coord[4][0],
                        MeBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ve") { 
                    props.setVeBVals({    
                        VeBSym:"T",      
                        VeBPlanetX: p.coord[0][0],
                        VeBPlanetY: p.coord[0][1],
                        VeBSign: p.sign,
                        VeBSignSym: p.signSymbol,
                        VeBSignX: p.coord[2][0],
                        VeBSignY: p.coord[2][1],
                        VeBDegree: p.degree,
                        VeBDegreeX: p.coord[1][0],
                        VeBDegreeY: p.coord[1][1],
                        VeBMinute: p.minute,
                        VeBMinuteX: p.coord[3][0],
                        VeBMinuteY: p.coord[3][1],
                        VeBRX:  p.rx,
                        VeBRXX: p.coord[4][0],
                        VeBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Su") { 
                    props.setSuBVals({ 
                        SuBSym:p.planetSymbol,         
                        SuBPlanetX: p.coord[0][0],
                        SuBPlanetY: p.coord[0][1],
                        SuBSign: p.sign,
                        SuBSignSym: p.signSymbol,
                        SuBSignX: p.coord[2][0],
                        SuBSignY: p.coord[2][1],
                        SuBDegree: p.degree,
                        SuBDegreeX: p.coord[1][0],
                        SuBDegreeY: p.coord[1][1],
                        SuBMinute: p.minute,
                        SuBMinuteX: p.coord[3][0],
                        SuBMinuteY: p.coord[3][1],
                        SuBRX: p.coord[4][0],
                        SuBRY: p.coord[4][1]
                    })
                }
                
                if (p.planet == "Ma") { 
                    props.setMaBVals({
                        MaBSym:"U",          
                        MaBPlanetX: p.coord[0][0],
                        MaBPlanetY: p.coord[0][1],
                        MaBSign: p.sign,
                        MaBSignSym: p.signSymbol,
                        MaBSignX: p.coord[2][0],
                        MaBSignY: p.coord[2][1],
                        MaBDegree: p.degree,
                        MaBDegreeX: p.coord[1][0],
                        MaBDegreeY: p.coord[1][1],
                        MaBMinute: p.minute,
                        MaBMinuteX: p.coord[3][0],
                        MaBMinuteY: p.coord[3][1],
                        MaBRX: p.rx,
                        MaBRXX: p.coord[4][0],
                        MaBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ju") { 
                    props.setJuBVals({ 
                        JuBSym:"V",         
                        JuBPlanetX: p.coord[0][0],
                        JuBPlanetY: p.coord[0][1],
                        JuBSign: p.sign,
                        JuBSignSym: p.signSymbol,
                        JuBSignX: p.coord[2][0],
                        JuBSignY: p.coord[2][1],
                        JuBDegree: p.degree,
                        JuBDegreeX: p.coord[1][0],
                        JuBDegreeY: p.coord[1][1],
                        JuBMinute: p.minute,
                        JuBMinuteX: p.coord[3][0],
                        JuBMinuteY: p.coord[3][1],
                        JuBRX: p.rx,
                        JuBRXX: p.coord[4][0],
                        JuBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Sa") { 
                    props.setSaBVals({
                        SaBSym:"W",          
                        SaBPlanetX: p.coord[0][0],
                        SaBPlanetY: p.coord[0][1],
                        SaBSign: p.sign,
                        SaBSignSym: p.signSymbol,
                        SaBSignX: p.coord[2][0],
                        SaBSignY: p.coord[2][1],
                        SaBDegree: p.degree,
                        SaBDegreeX: p.coord[1][0],
                        SaBDegreeY: p.coord[1][1],
                        SaBMinute: p.minute,
                        SaBMinuteX: p.coord[3][0],
                        SaBMinuteY: p.coord[3][1],
                        SaBRX: p.rx,
                        SaBRXX: p.coord[4][0],
                        SaBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ur") { 
                    props.setUrBVals({  
                        UrBSym:"X",        
                        UrBPlanetX: p.coord[0][0],
                        UrBPlanetY: p.coord[0][1],
                        UrBSign: p.sign,
                        UrBSignSym: p.signSymbol,
                        UrBSignX: p.coord[2][0],
                        UrBSignY: p.coord[2][1],
                        UrBDegree: p.degree,
                        UrBDegreeX: p.coord[1][0],
                        UrBDegreeY: p.coord[1][1],
                        UrBMinute: p.minute,
                        UrBMinuteX: p.coord[3][0],
                        UrBMinuteY: p.coord[3][1],
                        UrBRX: p.rx,
                        UrBRXX: p.coord[4][0],
                        UrBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ne") { 
                    props.setNeBVals({  
                        NeBSym:"Y",        
                        NeBPlanetX: p.coord[0][0],
                        NeBPlanetY: p.coord[0][1],
                        NeBSign: p.sign,
                        NeBSignSym: p.signSymbol,
                        NeBSignX: p.coord[2][0],
                        NeBSignY: p.coord[2][1],
                        NeBDegree: p.degree,
                        NeBDegreeX: p.coord[1][0],
                        NeBDegreeY: p.coord[1][1],
                        NeBMinute: p.minute,
                        NeBMinuteX: p.coord[3][0],
                        NeBMinuteY: p.coord[3][1],
                        NeBRX: p.rx,
                        NeBRXX: p.coord[4][0],
                        NeBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Pl") { 
                    props.setPlBVals({   
                        PlBSym:"Z",       
                        PlBPlanetX: p.coord[0][0],
                        PlBPlanetY: p.coord[0][1],
                        PlBSign: p.sign,
                        PlBSignSym: p.signSymbol,
                        PlBSignX: p.coord[2][0],
                        PlBSignY: p.coord[2][1],
                        PlBDegree: p.degree,
                        PlBDegreeX: p.coord[1][0],
                        PlBDegreeY: p.coord[1][1],
                        PlBMinute: p.minute,
                        PlBMinuteX: p.coord[3][0],
                        PlBMinuteY: p.coord[3][1],
                        PlBRX: p.rx,
                        PlBRXX: p.coord[4][0],
                        PlBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ra") { 
                    props.setRaBVals({
                        RaBSym:"<",          
                        RaBPlanetX: p.coord[0][0],
                        RaBPlanetY: p.coord[0][1],
                        RaBSign: p.sign,
                        RaBSignSym: p.signSymbol,
                        RaBSignX: p.coord[2][0],
                        RaBSignY: p.coord[2][1],
                        RaBDegree: p.degree,
                        RaBDegreeX: p.coord[1][0],
                        RaBDegreeY: p.coord[1][1],
                        RaBMinute: p.minute,
                        RaBMinuteX: p.coord[3][0],
                        RaBMinuteY: p.coord[3][1],
                        RaBRX: p.rx,
                        RaBRXX: p.coord[4][0],
                        RaBRXY: p.coord[4][1],
                        RXBSym: 'M' 
                    })
                }
                if (p.planet == "Ke") { 
                    props.setKeBVals({ 
                        KeBSym:">",         
                        KeBPlanetX: p.coord[0][0],
                        KeBPlanetY: p.coord[0][1],
                        KeBSign: p.sign,
                        KeBSignSym: p.signSymbol,
                        KeBSignX: p.coord[2][0],
                        KeBSignY: p.coord[2][1],
                        KeBDegree: p.degree,
                        KeBDegreeX: p.coord[1][0],
                        KeBDegreeY: p.coord[1][1],
                        KeBMinute: p.minute,
                        KeBMinuteX: p.coord[3][0],
                        KeBMinuteY: p.coord[3][1],
                        KeBRX: p.rx,
                        KeBRXX: p.coord[4][0],
                        KeBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "Ch") { 
                    props.setChBVals({  
                        ChBSym:"t",        
                        ChBPlanetX: p.coord[0][0],
                        ChBPlanetY: p.coord[0][1],
                        ChBSign: p.sign,
                        ChBSignSym: p.signSymbol,
                        ChBSignX: p.coord[2][0],
                        ChBSignY: p.coord[2][1],
                        ChBDegree: p.degree,
                        ChBDegreeX: p.coord[1][0],
                        ChBDegreeY: p.coord[1][1],
                        ChBMinute: p.minute,
                        ChBMinuteX: p.coord[3][0],
                        ChBMinuteY: p.coord[3][1],
                        ChBRX: p.rx,
                        ChBRXX: p.coord[4][0],
                        ChBRXY: p.coord[4][1]
                    })
                }
                if (p.planet == "ASC") { 
                    props.setASCBVals({
                        ASCBSym:"a",          
                        ASCBPlanetX: p.coord[0][0],
                        ASCBPlanetY: p.coord[0][1],
                        ASCBSign: p.sign,
                        ASCBSignSym: p.signSymbol,
                        ASCBSignX: p.coord[2][0],
                        ASCBSignY: p.coord[2][1],
                        ASCBDegree: p.degree,
                        ASCBDegreeX: p.coord[1][0],
                        ASCBDegreeY: p.coord[1][1],
                        ASCBMinute: p.minute,
                        ASCBMinuteX: p.coord[3][0],
                        ASCBMinuteY: p.coord[3][1]
                    })
            
                }
                if (p.planet == "DSC") { 
                    props.setDSCBVals({
                        DSCBSym:"DC",          
                        DSCBPlanetX: p.coord[0][0],
                        DSCBPlanetY: p.coord[0][1],
                        DSCBSign: p.sign,
                        DSCBSignSym: p.signSymbol,
                        DSCBSignX: p.coord[2][0],
                        DSCBSignY: p.coord[2][1],
                        DSCBDegree: p.degree,
                        DSCBDegreeX: p.coord[1][0],
                        DSCBDegreeY: p.coord[1][1],
                        DSCBMinute: p.minute,
                        DSCBMinuteX: p.coord[3][0],
                        DSCBMinuteY: p.coord[3][1]
                    })
                }
                if (p.planet == "IC") { 
                    props.setICBVals({ 
                        ICBSym:"c",         
                        ICBPlanetX: p.coord[0][0],
                        ICBPlanetY: p.coord[0][1],
                        ICBSign: p.sign,
                        ICBSignSym: p.signSymbol,
                        ICBSignX: p.coord[2][0],
                        ICBSignY: p.coord[2][1],
                        ICBDegree: p.degree,
                        ICBDegreeX: p.coord[1][0],
                        ICBDegreeY: p.coord[1][1],
                        ICBMinute: p.minute,
                        ICBMinuteX: p.coord[3][0],
                        ICBMinuteY: p.coord[3][1]
                    })
                }
                if (p.planet == "MC") { 
                    props.setMCBVals({ 
                        MCBSym:"b",         
                        MCBPlanetX: p.coord[0][0],
                        MCBPlanetY: p.coord[0][1],
                        MCBSign: p.sign,
                        MCBSignSym: p.signSymbol,
                        MCBSignX: p.coord[2][0],
                        MCBSignY: p.coord[2][1],
                        MCBDegree: p.degree,
                        MCBDegreeX: p.coord[1][0],
                        MCBDegreeY: p.coord[1][1],
                        MCBMinute: p.minute,
                        MCBMinuteX: p.coord[3][0],
                        MCBMinuteY: p.coord[3][1]
                    })
                }
                if (p.planet == "LoFo") { 
                    props.setLoFoBVals({ 
                        LoFoBSym:";",         
                        LoFoBPlanetX: p.coord[0][0],
                        LoFoBPlanetY: p.coord[0][1],
                        LoFoBSign: p.sign,
                        LoFoBSignSym: p.signSymbol,
                        LoFoBSignX: p.coord[2][0],
                        LoFoBSignY: p.coord[2][1],
                        LoFoBDegree: p.degree,
                        LoFoBDegreeX: p.coord[1][0],
                        LoFoBDegreeY: p.coord[1][1],
                        LoFoBMinute: p.minute,
                        LoFoBMinuteX: p.coord[3][0],
                        LoFoBMinuteY: p.coord[3][1]
                    })
                }
                
                })
            }
          
          },[custom])
    console.log(custom)
            
    return <div className="arrow-group">
         <StyledContainer>
            <StyledButton onClick={handleBackClick} aria-label="back">
            <CurvedLeftArrow  width='1rem' height='1rem' fill = 'rgb(77, 77, 77)'/>   
            </StyledButton>
            <div className='time-button-label libre-franklin-chart'>MONTH</div>
            <StyledButton onClick={handleForwardClick} aria-label="forward">
                <CurvedRightArrow width='1rem' height='1rem' fill = 'rgb(77, 77, 77)' />  
            </StyledButton>
        </StyledContainer>

    </div>
        
}


